/* eslint-disable import/no-cycle */
import * as types from './types';
import storageApi from '@/modules/storage/api/storageApi';

const actions = {
  [types.FETCH_CAMPAIGN_FILE_NAMES]: (context, payload) => storageApi.getFileNames(context.rootState.campaigns.campaign.id, payload)
    .then((response) => response?.files?.map((file) => file.name)),
  [types.FETCH_CAMPAIGN_FILE]: (context, payload) => storageApi.getFile(context.rootState.campaigns.campaign.id, payload)
    .then((response) => response.content)
    .catch(() => []),
  [types.DELETE_CAMPAIGN_FILE]: (context, payload) => storageApi.deleteFile(context.rootState.campaigns.campaign.id, payload)
    .then((response) => response)
    .catch((error) => error),
};

export default actions;
